"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceOf = exports.isBrowser = exports.setWindow = exports.globalObject = void 0;
exports.globalObject = (typeof window === 'object' && window) ||
    (typeof globalThis === 'object' && globalThis) ||
    (typeof global === 'object' && global) ||
    Function('return this')();
var setWindow = function (win) { return (exports.globalObject = win); };
exports.setWindow = setWindow;
var isBrowser = function (obj) {
    return typeof window !== 'undefined' && obj === exports.globalObject;
};
exports.isBrowser = isBrowser;
function isInstanceOf(instance, constructor) {
    return typeof constructor === 'function' && instance instanceof constructor;
}
exports.isInstanceOf = isInstanceOf;
__exportStar(require("./types"), exports);
